<template>
  <div v-show="$store.state.layout === 'landing'"
       class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>

  <sidenav :headerPageCardBg="$store.state.mcolor"
           :class="[
      $store.state.isTransparent,
      $store.state.isRTL ? 'fixed-end' : 'fixed-start'
    ]"
           v-if="this.$store.state.showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <div class=" min-height-600">
      <!-- nav -->
      <navbar :class="[navClasses]"
              :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'"
              :minNav="navbarMinimize"
              v-if="$store.state.showNavbar" />
      <router-view></router-view>
      <configurator :toggle="toggleConfigurator"
                    :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : '' ]" />
    </div>
    <app-footer v-show="$store.state.showFooter" />
  </main>

  <div class="background-loader" v-if="$store.state.isLoading">
    <div class="loader">
      <div class="inner one"></div>
      <div class="inner two"></div>
      <div class="inner three"></div>
    </div>
  </div>
</template>
<script>
  import { setupConnection } from "./services/SignalR/NotificationHubService";
  import Sidenav from "./examples/Sidenav";
  import Configurator from "@/examples/Configurator.vue";
  import Navbar from "@/examples/Navbars/Navbar.vue";
  import AppFooter from "@/examples/Footer.vue";
  import { mapMutations } from "vuex";

  export default {
    name: "App",
    components: {
      Sidenav,
      Configurator,
      Navbar,
      AppFooter
    },
    methods: {
      ...mapMutations(["toggleConfigurator", "navbarMinimize"])
    },
    computed: {
      navClasses() {
        return {
          "position-sticky bg-white left-auto top-2 z-index-sticky":
            this.$store.state.isNavFixed && !this.$store.state.darkMode,
          "position-sticky bg-default left-auto top-2 z-index-sticky":
            this.$store.state.isNavFixed && this.$store.state.darkMode,
          "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
            .isAbsolute,
          "px-0 mx-4": !this.$store.state.isAbsolute
        };
      },
      newReferralNotifications() {
        return this.$store.getters.newReferralNotifications;
      },
      myTicketsNotifications() {
        return this.$store.getters.myTicketsNotifications;
      },
    },
    watch: {
      newReferralNotifications(notifications) {
        localStorage.setItem('newReferralNotifications', JSON.stringify(notifications?.slice(Math.max(notifications.length - 500, 0)) ?? []));
      },
      myTicketsNotifications(notifications) {
        localStorage.setItem('myTicketsNotifications', JSON.stringify(notifications?.slice(Math.max(notifications.length - 500, 0)) ?? []));
      }
    },
    mounted() {
      document.addEventListener('hide.bs.modal', function () {

        if (document.activeElement) {
          document.activeElement.blur();
        }
      });

      setTimeout(() => setupConnection(), 500);
    },
    beforeMount() {
      this.$store.state.isTransparent = "bg-transparent";
      this.$store.state.isRTL = true;
      document.querySelector("html").setAttribute("lang", "ar");
      document.querySelector("html").setAttribute("dir", "rtl");
      document.querySelector("#app").classList.add("rtl");
    },
    beforeUnmount() {
      this.$store.state.isRTL = false;
      document.querySelector("html").removeAttribute("lang");
      document.querySelector("html").removeAttribute("dir");
      document.querySelector("#app").classList.remove("rtl");
    }
  };
</script>
